<template>
  <div @click="exportToCsv">
    <slot>
      <vs-button color="success" type="filled">{{ $t('Export xls') }}</vs-button>
    </slot>
  </div>
</template>



<script>
import exportCsv from "@mixins/exportCsv.js";

export default {
  mixins: [exportCsv],
  props: ["data", "name", "columns" , "unshiftCols"],
  methods: {
    exportToCsv() {
      this.exportJsonToCsv({
        data: this.data || [],
        name: this.name || "_",
        columns: this.columns || [],
        unshiftCols :this.unshiftCols || []
      });
    },
  },
};
</script>

